import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11"><path d="M6 1v4h4v1H6v4H5V6H1V5h4V1z" fill-rule="evenodd"/></svg>`;

export { symbol as default };
